export default __webpack_public_path__ + "static/media/LOGO_ASF.e85cb06b.svg";